import {
  KeycloakServiceDefault,
  AuthServiceFactory,
  ServiceType
} from 'virava';

export const viravaDefault = AuthServiceFactory.create(
  ServiceType.DEFAULT
) as KeycloakServiceDefault;
